import React from 'react';

import { RouteObject } from 'react-router-dom';

const AdvanceInvoicesList = React.lazy(
  () => import('@/pages/AdvanceInvoices/views/AdvanceInvoicesList'),
);

/**
 * Tabs of «Рахунки». Design also has «Остаточні» and «Акти приймання передачі» — add a path here,
 * a route below and a link in `useAdvanceInvoicesNavLinks` when their backends land.
 */
export const advanceInvoicesPath = {
  Advance: '',
};

export const advanceInvoicesRoutes: RouteObject[] = [
  { index: true, element: <AdvanceInvoicesList /> },
];
